import { appVersion, defaultStartingElo } from "constants/gameDefaults";
import { GameModeEnum, GameStateEnum, GameStatusEnum, Game } from "./game";
import { User } from "./user";

export interface Lobby {
  id: string | null;
  creator: string;
  creatorElo: number | null;
  gameId: string;
  mode: GameModeEnum;
  players: string[];
  state: GameStateEnum;
  status: GameStatusEnum;
  date: string;
  version: string;
}

export const getNewLobby = (user: User | null, game: Game | null): Lobby => {
  if (!user) {
    throw new Error("User is null");
  }

  if (!game || !game.id) {
    throw new Error("Game is null or Game.id is null");
  }

  return {
    id: null,
    creator: user.uid,
    creatorElo: user.currentElo ?? defaultStartingElo,
    gameId: game.id,
    mode: game.mode,
    players: game.players,
    state: GameStateEnum.WAITING,
    status: GameStatusEnum.CONNECTED,
    date: new Date().toISOString(),
    version: `${appVersion}`,
  };
};
